import { incYenOf } from '../../../lib/pricing';
const seminar = {
  // HeroSection
  'seminar.hero.homeLink': 'ホーム',
  'seminar.hero.currentPage': '体験講座',
  'seminar.hero.title': '体験講座「執事の作法・入門」',
  'seminar.hero.titleEn': 'ONE-DAY SEMINAR',
  'seminar.hero.lead': '1日6時間で執事の世界を体験する執事講座です。本科と同じ講師・同じ教室で、白手袋を着けてティーサービスや基本所作を実習する執事体験をご用意しています。',
  'seminar.hero.imgAlt': '白手袋でティーサービスの所作を体験する参加者と指導する講師',

  // Overview
  'seminar.overview.label': 'OVERVIEW',
  'seminar.overview.title': '体験講座の概要',
  'seminar.overview.titleEn': 'One-Day Seminar Overview',
  'seminar.overview.name': '体験講座「執事の作法・入門」',
  'seminar.overview.nameEn': 'ONE-DAY SEMINAR',
  'seminar.overview.duration': '1日',
  'seminar.overview.totalHours': '6時間（90分×4コマ）',
  'seminar.overview.price': incYenOf('ac-trial'),
  'seminar.overview.currency': '円',
  'seminar.overview.taxNote': '（税込）',
  'seminar.overview.capacity': '定員6名（完全少人数制）',
  'seminar.overview.location': '本校（東京・お台場）',
  'seminar.overview.target': '執事・バトラーの仕事に興味がある方、本科の受講を検討中の方、上質な接遇を学びたい社会人',
  'seminar.overview.scheduleLabel': '開催日程',
  'seminar.overview.scheduleText': 'お知らせページで随時ご案内します',
  'seminar.overview.badge.0': '1日完結・6時間',
  'seminar.overview.badge.1': '参加費は本科受講料に全額充当',
  'seminar.overview.badge.2': '本科と同じ講師が担当',

  // Program
  'seminar.program.label': 'PROGRAM',
  'seminar.program.title': '1日の流れ',
  'seminar.program.titleEn': 'Programme Timeline',
  'seminar.program.0.time': '1限（10:00 – 11:30）',
  'seminar.program.0.title': '執事という職業',
  'seminar.program.0.titleEn': 'The Butler Profession',
  'seminar.program.0.description': '執事という職業の歴史的背景から、個人邸宅・ホテル・企業といった現代における活躍の場まで、キャリアの実際を本科と同じ講師が講義します。海外と日本における執事像の違いや、これからの執事に求められる資質についてもお話しします。',
  'seminar.program.1.time': '2限（11:45 – 13:15）',
  'seminar.program.1.title': '執事の所作',
  'seminar.program.1.titleEn': 'Butler Comportment',
  'seminar.program.1.description': '立ち姿・歩き方・ドアサービス・物の受け渡しといった基本所作を、白手袋を着けて一つずつ練習します。鏡を使った自己チェックと講師による個別指導で、見学ではなく実際に体を動かしながら執事の所作を体験いただきます。お辞儀は、上体を約15度傾ける会釈、約30度傾ける普通礼、約45度傾ける敬礼の三つを、場面に応じて使い分けます。日常の業務で最も多く使うのは普通礼で、丁寧なお辞儀では先に言葉を伝えてから礼に移るという順番まで、実際に動きながら確かめていきます。',
  'seminar.program.2.time': '3限（14:00 – 15:30）',
  'seminar.program.2.title': 'ティーサービス実習',
  'seminar.program.2.titleEn': 'Tea Service Practice',
  'seminar.program.2.description': '茶葉の基礎知識、温度と蒸らし時間の管理、美しい注ぎ方までを一人ずつ実習します。受講生同士でサービスし合うロールプレイングを通じて、実際に紅茶を淹れて提供する一連の流れを体験いただきます。本格的な茶器を使った実習は体験講座ならではの内容です。手順の基本形は、あらかじめポットとカップに湯を入れて茶器を温め、茶葉は一人あたり三グラムを量って入れ、汲みたての新鮮な水を沸騰させた熱湯を注ぎ、ふたをして三分を目安に蒸らす、という流れです（適量と蒸らし時間は茶葉の銘柄ごとに違うため、パッケージの表示を基準に調整します）。\n\nお出しするときは、カップ＆ソーサーをお客様の正面から少し右へ寄せた位置に据えます。取っ手は右手がそのまま掛かる三時の向きにそろえ、ティースプーンはソーサーの手前側に、取っ手と同じ向きで添えます。会話が途切れた瞬間を待って右側から静かに歩み寄り、「失礼いたします」とひと声かけてから、ソーサーを両手で支えたまま音を立てずに下ろします。テーブルの端とソーサーの縁のあいだに三〜五センチほどの余白を残すのが目安です。講座では、置く前に位置を決めて置いてから動かさない、という一連の動きを繰り返し練習していただきます。\n\nソーサーを置いたあとは半歩下がって全体を見渡し、カップの向き・スプーンの位置・テーブルの端との間隔が最初に決めたとおりに収まっているかを目で確かめてから、次の動作に移ります。おかわりの声かけは、カップの中身が四分の一を切ったあたりが合図です。飲み干されてから伺うのでは遅く、かといって半分残っているうちに声をかけるのも急かす印象になるため、講座ではこの見極めを受講生同士で確かめ合っていただきます。',
  'seminar.program.3.time': '4限（15:45 – 17:15）',
  'seminar.program.3.title': 'テーブルセッティング基礎と質疑応答',
  'seminar.program.3.titleEn': 'Table Setting & Consultation',
  'seminar.program.3.description': '朝食セッティングの基本を体験した後、本科3コースの違いとそれぞれの特徴をご説明します。その後、質疑応答と希望者への個別相談の時間を設け、あなたに最適な学びのステップを一緒に考えます。',

  // GainItems
  'seminar.gain.label': 'WHY ATTEND',
  'seminar.gain.title': '参加でわかること・できること',
  'seminar.gain.titleEn': 'What You Will Gain',
  'seminar.gain.0.title': '本物の執事教育の空気を肌で感じられる',
  'seminar.gain.0.description': '本科と同じ講師・同じ教室で学ぶことで、日本の執事学校であるアカデミーの雰囲気や教育の質を実際に体感いただけます。入学後のミスマッチを防ぐ最良の機会です。',
  'seminar.gain.1.title': '講師に直接キャリア相談ができる',
  'seminar.gain.1.description': '4限の個別相談では、あなたの目標やご経験に合わせたキャリアプランを講師と一緒に考えます。本科受講後の具体的な進路イメージを描くことができます。',
  'seminar.gain.2.title': '本科3コースの違いと自分に合う課程がわかる',
  'seminar.gain.2.description': 'エッセンシャル・アドバンス・マスターの違いや、未経験からプロまでの標準的な学習ステップを具体的に理解でき、最適なコース選びが可能になります。',
  'seminar.gain.3.title': '白手袋を着けてのサービス体験',
  'seminar.gain.3.description': '執事の象徴である白手袋を実際に着用し、ティーサービスや所作の練習を行います。本科受講をより具体的にイメージできる実践的な体験です。',

  // MainCourses
  'seminar.courses.label': 'NEXT STEP',
  'seminar.courses.title': '本科コースへの道',
  'seminar.courses.titleEn': 'Pathways to the Full Courses',
  'seminar.courses.description': '体験講座参加費（33,000円・税込）は、ご参加から1年以内の本科お申込み時に全額充当されます。',
  'seminar.courses.currency': '円',
  'seminar.courses.taxNote': '（税込）',
  'seminar.courses.viewLink': 'コース詳細を見る',
  'seminar.courses.creditNote': '※体験講座の参加費は本科受講料に全額充当されます（参加から1年以内）',
  'seminar.courses.0.name': 'エッセンシャルコース',
  'seminar.courses.0.duration': '1ヶ月・8日間・48時間',
  'seminar.courses.0.description': '基礎から始める入門課程。テーブルマナーから基本的なサービススキルまで、執事の土台を体系的に固めます。',
  'seminar.courses.1.name': 'アドバンスコース',
  'seminar.courses.1.duration': '2ヶ月・12日間・72時間',
  'seminar.courses.1.description': 'エッセンシャルの内容を含んだ上で、専門技能を磨く中級課程。ワインサービスやイベント運営まで、より高度なホスピタリティを習得します。未経験からの直接受講も可能です。',
  'seminar.courses.2.name': 'マスターコース',
  'seminar.courses.2.duration': '3ヶ月・16日間・96時間',
  'seminar.courses.2.description': 'エッセンシャル・アドバンスの内容を含んだ上で、プロを目指す最上級課程。管理能力からリーダーシップまで、執事長としての全領域を網羅します。未経験からの直接受講も可能です。',

  // FAQSection
  'seminar.faq.label': 'FAQ',
  'seminar.faq.title': 'よくあるご質問',
  'seminar.faq.titleEn': 'Frequently Asked Questions',
  'seminar.faq.footer': 'その他のご質問はフォームよりお寄せください',
  'seminar.faq.0.question': 'まったくの未経験ですが大丈夫ですか？',
  'seminar.faq.0.answer': 'はい。体験講座は未経験の方のための入門プログラムです。道具と白手袋は当日お貸ししますので、筆記用具のみお持ちください。',
  'seminar.faq.1.question': '参加費の本科充当に期限はありますか？',
  'seminar.faq.1.answer': '体験講座ご参加から1年以内の本科お申込みを対象とする予定です。詳細はお申込み時のご案内に従ってください。',
  'seminar.faq.2.question': '服装の指定はありますか？',
  'seminar.faq.2.answer': '動きやすい綺麗めの服装（襟付きシャツ推奨）でお越しください。ジャケットの着用は任意です。',

  // CTASection
  'seminar.cta.label': 'APPLY NOW',
  'seminar.cta.title': '体験講座に参加する',
  'seminar.cta.body': '次回の開催日程はお知らせページでご確認ください。お申込みはフォームより承ります。',
  'seminar.cta.note': '※定員6名・先着順',
  'seminar.cta.apply': '申込フォームへ',
  'seminar.cta.news': '開催日程を確認する',

  // RelatedPages
  'seminar.related.label': 'LEARN MORE',
  'seminar.related.title': '関連ページ',
  'seminar.related.titleEn': 'Explore Further',
  'seminar.related.viewLink': '詳しく見る',
  'seminar.related.0.title': 'コース一覧',
  'seminar.related.0.desc': '3つの本科コースを見る',
  'seminar.related.1.title': '入学案内',
  'seminar.related.1.desc': 'お申込みまでの流れ',
  'seminar.related.2.title': 'よくある質問',
  'seminar.related.2.desc': '受講に関する疑問にお答えします',
  'seminar.related.3.title': 'アクセス',
  'seminar.related.3.desc': '東京・お台場の校舎へのご案内',

  // HeroSection extras
  'seminar.hero.admissionLink': '入学案内',
  'seminar.hero.imgTitle': '日本執事アカデミー 体験講座「執事の作法・入門」',

  // SeminarOverview extras
  'seminar.overview.altTitle': '開催概要',
  'seminar.overview.tableCol.item': '項目',
  'seminar.overview.tableCol.content': '内容',
  'seminar.overview.row.duration': '所要',
  'seminar.overview.row.hours': '総時間',
  'seminar.overview.row.price': '参加費',
  'seminar.overview.row.capacity': '定員',
  'seminar.overview.row.location': '会場',
  'seminar.overview.row.target': '対象',
  'seminar.overview.row.schedule': '開催日',
  'seminar.overview.footerNote': '※表示価格はすべて税込です。定員に達し次第、受付を締切ります。',
  'seminar.overview.scheduleHtml': '開催日程は<a href="/news" class="text-accent-600 hover:text-accent-500 underline underline-offset-2 transition-colors">お知らせページ</a>で随時ご案内します',

  // ProgramTimeline extras
  'seminar.program.altTitle': '体験講座では何ができる？',
  'seminar.program.description': '見学ではなく、実際に手を動かす実習中心のプログラムです。白手袋を着けて、執事の技能を基礎から学べる執事学校ならではの本物の教育を1日で体験いただけます。',
  'seminar.program.note': '※上記は標準的なプログラムです。進行状況により内容が一部前後する場合がございます。',

  // GainSection extras
  'seminar.gain.altTitle': '体験講座で得られること',

  // CourseIntro extras
  'seminar.courses.altTitle': '本科コースのご紹介',
  'seminar.courses.viewDetail': '詳しく見る',
  'seminar.courses.taxLabel': '（税込）',

  // WhatToBring
  'seminar.bring.label': 'WHAT TO BRING',
  'seminar.bring.title': '持ち物・服装',
  'seminar.bring.items.title': '持ち物',
  'seminar.bring.items.main': '筆記用具のみお持ちください。',
  'seminar.bring.items.note': '白手袋・実習用の道具・テキストは、すべて当日貸与いたします。',
  'seminar.bring.attire.title': '服装',
  'seminar.bring.attire.main': '動きやすい綺麗めの服装でお越しください。',
  'seminar.bring.attire.note': '襟付きシャツを推奨します。ジーンズはご遠慮ください。ジャケットの着用は任意です。',

  // ImportantNotes
  'seminar.notes.title': '注意事項',
  'seminar.notes.0': '最少催行人数は2名です。開催7日前までに不催行が決定した場合は、全額返金または別日への振替となります。',
  'seminar.notes.1': '講義の録音・録画はご遠慮ください。',
  'seminar.notes.2': 'お子様連れでのご参加は事前にご相談ください。',

  // FeeCarryOver
  'seminar.fee.lead': '体験講座の参加費は',
  'seminar.fee.message': '参加費',
  'seminar.fee.amount': ` ¥${incYenOf('ac-trial')}`,
  'seminar.fee.suffix': 'は、',
  'seminar.fee.target': '本科コースお申込み時に',
  'seminar.fee.action': '受講料へ全額充当',
  'seminar.fee.end': 'されます。',

  // ApplicationForm
  'seminar.form.label': 'APPLICATION',
  'seminar.form.title': 'お申込み',
  'seminar.form.lead': '以下のフォームに必要事項をご入力のうえ、内容確認へお進みください。',
  'seminar.form.contact.intro': 'フォームのほか、お電話',
  'seminar.form.contact.or': 'またはメール',
  'seminar.form.contact.also': 'でもお申込みを承ります。',
  'seminar.form.contact.hours': '受付時間: 平日 10:00〜17:00',
  'seminar.form.field.name': '氏名',
  'seminar.form.field.furigana': 'ふりがな',
  'seminar.form.field.email': 'メールアドレス',
  'seminar.form.field.phone': '電話番号',
  'seminar.form.field.date': '希望日',
  'seminar.form.field.interest': '本科への関心',
  'seminar.form.field.question': 'ご質問など（任意）',
  'seminar.form.required': '必須',
  'seminar.form.placeholder.name': '例: 執事 太郎',
  'seminar.form.placeholder.furigana': '例: しつじ たろう',
  'seminar.form.placeholder.email': '例: taro@example.com',
  'seminar.form.placeholder.phone': '例: 090-1234-5678',
  'seminar.form.placeholder.date': '例: 8月の土日、平日夜など',
  'seminar.form.placeholder.interest': '選択してください',
  'seminar.form.placeholder.question': 'ご不明な点がございましたら、自由にご記入ください。',
  'seminar.form.interest.considering': '検討中',
  'seminar.form.interest.researching': '情報収集',
  'seminar.form.interest.undecided': '未定',
  'seminar.form.submit': 'この内容で申し込む',
  'seminar.form.error.name': '氏名は必須です',
  'seminar.form.error.furigana': 'ふりがなは必須です',
  'seminar.form.error.email.required': 'メールアドレスは必須です',
  'seminar.form.error.email.invalid': '有効なメールアドレスを入力してください',
  'seminar.form.error.phone': '電話番号は必須です',
  'seminar.form.error.interest': '本科への関心をお選びください',
  'seminar.form.error.question': '500文字以内で入力してください',

  // Last updated
  'seminar.lastUpdated': '最終更新: 2026年7月8日',
};

export default seminar;
